var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"category-image",attrs:{"href":_vm.href},on:{"click":_vm.click}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.name,"width":"100%","height":"auto"}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }